import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const LockKeyholeIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M13 15a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2Z" />
      <path
        fillRule="evenodd"
        d="M6 7v3H5a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3h-1V7A6 6 0 1 0 6 7Zm6-4a4 4 0 0 0-4 4v3h8V7a4 4 0 0 0-4-4ZM4 13c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v7c0 .6-.4 1-1 1H5a1 1 0 0 1-1-1v-7Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default LockKeyholeIcon;
